(function ($, Cobalt, undefined) {
    Cobalt.MultiFileUpload = {
        deleteAttachmentRoute: null,
        fileUploadObjects: null,
        initialize: function () {

            Cobalt.Comment.onCommentCreated(function ($newComment) {
                // Newly Added Images - Add left and right padding to image based on image width, if it is less than 115px high
                setTimeout(function () {
                    Cobalt.MultiFileUpload.addAttachmentPadding($newComment);
                }, 1200);
                
                var fileUploadObject = Cobalt.MultiFileUpload.fileUploadObjects["j-attachments-0"];
                if (fileUploadObject) {
                    fileUploadObject.CurrentFileCount = 0; //reset default editor comment count
                    fileUploadObject.toggleMaxAttachmentsMessage(false);
                    if (fileUploadObject.AttachButton.is(":disabled")) {
                        fileUploadObject.AttachButton.removeAttr("disabled");
                        fileUploadObject.AttachToElement.removeClass("disabled");
                        $(fileUploadObject.Form).find(":input").each(function () { $(this).removeAttr("disabled"); });
                    }
                }                
            });
            
            Cobalt.runOnHtmlInsert(function ($parent) {
                var multiFileUploadInput = $parent.find("input.j-multi-file-upload");
                multiFileUploadInput.each(function () {
                    if ($(this).data("Cobalt.MultiFileUpload")) {
                        return;
                    }
                    var attachToElementID = $(this).attr("data-attach-to-element-id");
                    var buttonElementID = $(this).attr("data-button-element-id");                   

                    var fileUpload = new Cobalt.FileUpload($(this), attachToElementID, buttonElementID);
                    Cobalt.MultiFileUpload.fileUploadObjects = {};
                    Cobalt.MultiFileUpload.fileUploadObjects[attachToElementID] = fileUpload;
                    $(this).data("Cobalt.MultiFileUpload", "1");

                    fileUpload.ButtonElement.on("mouseenter", function (e) {
                        e.stopImmediatePropagation();
                        var $that = $(this).parent();
                        var container = "<div class='minimal-drop-box'><span class='minimal-drop-text'>Drop image to upload.</span></div>";
                        $that.after(container).fadeIn();
                        $(this).parent(".form-tools").css('float', 'none'); // remove float so drop container can expand
                        
                    });                                      
                    
                    fileUpload.ButtonElement.on("mouseleave", function (e) {
                        Cobalt.MultiFileUpload.uploadButtonMouseLeaveFunc();
                        $(this).parent(".form-tools").css('float', 'left'); // add float back
                    });
                });
            });
            
            //Attachment List Item
            $("body").on("mouseenter", ".j-attachment-image-item", function () {
                $(this).find(".j-attachment-image-name-container").fadeIn();
            });
            $("body").on("mouseleave", ".j-attachment-image-item", function () {
                $(this).find(".j-attachment-image-name-container").fadeOut();
            });            
        },
        addAttachmentPadding: function($container) {
            var $imageContainer;
            if ($container && $container.length) {
                    $imageContainer = $container.find('.attachment-image-container');
            } else {
                $imageContainer = $('.attachment-image-container');
            }
            $imageContainer.each(function () {
                var $image = $(this).find('img');
                if ($image.length && $image.is(":visible")) {
                    if ($image.width() < 100 && $image.height() < 115) {
                        $image.css('padding-left', '20px');
                        $image.css('padding-right', '20px');
                    }
                }
            });
        },
        uploadButtonMouseLeaveFunc: function() {
            $(".minimal-drop-box").remove();
            $(this).parent(".form-tools").css('float', 'left'); // add float back so that buttons line up properly
        }
    };
})(jQuery, Cobalt);

Cobalt.FileUpload = function (inputElement, attachToElementID, buttonElementID) {
    this.AttachToElement = attachToElementID != null ? $(".attachments[id='" + attachToElementID + "']") : null;
   
    this.FileInput = inputElement;
    this.Form = $(inputElement).parents("form").first().bind("fileAttached", this.fileAttached).bind("fileRemoved", this.fileRemoved);
    this.NewFileUpload = '';

    // Set the current file count
    if (this.AttachToElement != null) {
        var existingFiles = this.AttachToElement.find("li[data-id]");
        this.CurrentFileCount = existingFiles.length;
        for (var i = 0; i < existingFiles.length; i++) {
            this.bindFileEvents(existingFiles[i]);
        }
    }
    else {
        this.CurrentFileCount = 0;
    }

    if (this.AttachToElement != null && this.CurrentFileCount > 0) {
        this.AttachToElement.show();
    }

    // Max Files
    var maxFiles = parseInt(inputElement.attr("data-max-files"));
    if (maxFiles != null) {
        this.MaxFiles = maxFiles;
    }
    else {
        this.MaxFiles = 1;
    }

    // Field Set Label
    var fieldsetLabel = inputElement.attr("data-fieldset-label");
    if (fieldsetLabel) {
        this.FieldSetLabel = fieldsetLabel;
    }
    else {
        this.FieldSetLabel = "";
    }

    // Attach Button
    this.AttachButton = this.Form.find(":submit");

    if (this.AttachButton) {
        this.AttachButton.attr("value", inputElement.attr("data-button-value"));
    }

    if (this.CurrentFileCount >= this.MaxFiles) {
        this.AttachButton.attr("disabled", true);
        this.AttachToElement.addClass("disabled");
        this.toggleMaxAttachmentsMessage(true);
        $.info(this.Form);

        this.Form.find(".j-multi-file-upload").each(function () { $(this).attr("disabled", true); });
    }

    this.ButtonElement =  $(buttonElementID);    

    this.rebindAttachButton();
};

Cobalt.FileUpload.prototype =
{
    toggleMaxAttachmentsMessage: function(show) {
        var message = this.AttachToElement.next(".j-max-attachments-message");
        if (show) {
            if (message.length < 1) {
                this.AttachToElement.after($("<div>").addClass("field-errors").addClass("j-max-attachments-message").html("You have uploaded the maximum number of attachments (" + this.MaxFiles + ")."));
            }
            this.AttachToElement.next(".j-max-attachments-message").show();
        } else {
            if (message.length > 0) {
                message.hide();
            }
        }
    },

    // Methods
    fileAttached: function (event, fileUpload) {
        fileUpload.CurrentFileCount++;
        var errorSpan = $("div.attachment-errors#" + $(fileUpload.FileInput).attr("name"));
        errorSpan.remove();

        if (fileUpload.CurrentFileCount >= fileUpload.MaxFiles) {
            fileUpload.AttachButton.attr("disabled", true);
            fileUpload.AttachToElement.addClass("disabled");
            fileUpload.toggleMaxAttachmentsMessage(true);
            $(fileUpload.Form).find(":input").each(function () { $(this).attr("disabled", true); });
        }
        else {
            fileUpload.rebindAttachButton();
        }

        $(fileUpload.Form).resetForm();


    },
    fileRemoved: function (event, fileUpload) {
        // If the attach button was disabled due to the max file limitation, enable it.
        if (fileUpload.AttachButton.is(":disabled")) {
            fileUpload.AttachButton.removeAttr("disabled");
            fileUpload.AttachToElement.removeClass("disabled");
            fileUpload.toggleMaxAttachmentsMessage(false);
            $(fileUpload.Form).find(":input").each(function () { $(this).removeAttr("disabled"); });
        }
        fileUpload.CurrentFileCount--;
        if (fileUpload.CurrentFileCount == 0) {
            fileUpload.AttachToElement.hide();
        }
        fileUpload.rebindAttachButton();
    },
    isUploading: false,
    monitorForm: function (input, fileUpload) {
        if (this.isUploading == true) {
            return;
        }
        var form = fileUpload.Form;
        if (form.valid()) {
            this.AttachToElement.find(".j-error-message").hide();
            fileUpload.AttachButton.removeAttr("disabled");
            fileUpload.AttachToElement.removeClass("disabled");
            fileUpload.toggleMaxAttachmentsMessage(false);
            if (input.type == "file") {
                try {
                    this.isUploading = true;
                    form.submit();
                }
                catch (ex) {
                    try {
                        fileUpload.AttachButton.click();
                    }
                    catch (ex2) {
                    }

                }

            }
        }
        else {
            fileUpload.AttachButton.attr("disabled", true);
            fileUpload.AttachToElement.addClass("disabled");
            fileUpload.toggleMaxAttachmentsMessage(true);
        }
    },
    // Rebinds the attach button behavior so that submission doesn't occur more than once.
    rebindAttachButton: function () {

        var form = this.Form;
        var fileUpload = this;
        this.AttachButton.attr("disabled", true);
        
        var $inputs = form.find(":input");
        $inputs.each(function () {
            $(this).keypress(function () { fileUpload.monitorForm(this, fileUpload); });
            $(this).change(function () { fileUpload.monitorForm(this, fileUpload); });
        });

        var that = this;
        $(this.Form).unbind("submit");
        $(this.Form).ajaxForm({
            type: 'post',
            beforeSubmit: function () {
                var valid = form.valid();
                if (valid) {
                    fileUpload.AttachToElement.show();
                    fileUpload.AttachToElement.mask();
                }


                return valid;
            },
            success: function (result, a, b, c) {
                fileUpload.AttachToElement.unmask();
                var jsonResult = null;
                try {
                    jsonResult = JSON.parse(result);
                }
                catch (error) { }

                if (result.indexOf("HttpRequestTooLargeException") > -1) {
                    that.displayError(L.Global.Files.FileTooLarge("5 MB"));
                    $(fileUpload.Form).resetForm();
                }
                else if (jsonResult != null && jsonResult.Errors != undefined) {
                    var errorMessages = [];
                    for (var p in jsonResult.Errors) {
                        errorMessages.push(jsonResult.Errors[p]);
                    }
                    fileUpload.displayError("An error has occurred while trying to save the file you uploaded: " + errorMessages.join(", "));
                    $(fileUpload.Form).resetForm();
                    fileUpload.rebindAttachButton();
                }
                else {
                    that.attachFile(result);
                }
                that.isUploading = false;
            },
            // This occurs when IIS rejects the file size.
            error: function () {
                fileUpload.AttachToElement.unmask();
                fileUpload.displayError("An unknown error has occurred.");
                $(fileUpload.Form).resetForm();
                that.isUploading = false;
            }
        });

        this.ButtonElement.unbind("click");
        this.ButtonElement.click(function () {
            if ($.browser.msie) {
                // show the hidden form
                that.Form.parent().css("left", "auto").css("position", "relative");
            }
            else {
                that.FileInput.trigger("click");
            }
            Cobalt.MultiFileUpload.uploadButtonMouseLeaveFunc();
        });

        // Drag and Drop Attachments
        if ((typeof FileReader != "undefined" && FileReader != null)) {
            //Disable default drag and drop
            $(document).bind('drop dragover', function (e) {
                e.preventDefault();
            });
            
            var $fileInputElement = form.find(".j-dd");
            var id = $fileInputElement.attr("id");
            var name = $fileInputElement.attr("name");
            var $newElement = $('<input type="file" class="j-dd">');
            var showDrag = false;
            var timeout = -1;

            $newElement.attr("id", id).attr("name", name);
            $fileInputElement.after($newElement);
            $fileInputElement.remove();

            var $defaultDropZone = this.AttachToElement;
            if ($defaultDropZone.is(":not(visible)")) { //hidden
                var hoverClass = "attachment-drag-drop-hover";
                var hoverContainer = "<div class='attachment-drag-drop-container'><span class='drop-text'>Drop image to upload.</span></div>";

                $(document).bind("dragenter", function(e) {
                    if ($defaultDropZone.is(":not(visible)") && that.CurrentFileCount < that.MaxFiles) {
                        $defaultDropZone.show();
                        $defaultDropZone.addClass(hoverClass);
                    }
                    if ($defaultDropZone.find(".attachment-drag-drop-container").length === 0 && that.CurrentFileCount < that.MaxFiles) {
                        $defaultDropZone.append($(hoverContainer));
                    }
                    showDrag = true;
                });

                $(document).bind("dragover", function () {
                    showDrag = true;
                });

                $("html").bind("dragleave", function (e) {
                    showDrag = false;
                    clearTimeout(timeout);
                    timeout = setTimeout(function () {
                        if (!showDrag) {
                            if ($defaultDropZone.hasClass(hoverClass) && that.CurrentFileCount <= 0) {
                                $defaultDropZone.hide();
                            }
                            $defaultDropZone.removeClass(hoverClass);
                            $defaultDropZone.find(".attachment-drag-drop-container").remove();
                        }
                    }, 200);
                    
                });

                $(document).bind("drop", function (e) {
                    if (that.CurrentFileCount == that.MaxFiles) {
                        e.preventDefault();
                        return;
                    }
                    if ($defaultDropZone.hasClass(hoverClass) && that.CurrentFileCount <= 0 && !$defaultDropZone.is(":hover")) {
                        $defaultDropZone.hide();
                    }
                    $defaultDropZone.removeClass(hoverClass);
                    $defaultDropZone.find(".attachment-drag-drop-container").remove();
                });
            }
            
                $newElement.fileupload({
                    dropZone: $defaultDropZone,
                    autoUpload: true,
                    dataType: 'html',
                    add: function (e, data) {
                        $('body').append('<div class="loadmask"></div>');
                        data.submit();
                    },
                    send: function(e, data) {
                        //override because of default sets from ImageManager
                    },
                    done: function (e, data) {
                        try {
                            if (data.result.indexOf("HttpRequestTooLargeException") > -1) {
                                fileUpload.displayError(L.Global.Files.FileTooLarge("5 MB"));
                                return;
                            } else {
                                fileUpload.clearErrors();
                            }
                            var jsonResult = JSON.parse(data.result);
                            if (jsonResult !== undefined && jsonResult.Errors !== undefined) {
                                fileUpload.displayError(jsonResult.Errors["field-attachments"][0]);
                                return;
                            } else {
                                fileUpload.clearErrors();
                            }
                        }
                        catch (ex)
                        {
                        }
                        fileUpload.attachFile(data.result, true);
                        $('body').find('.loadmask').remove();
                    },
                    fail: function (e, data) {
                        try {
                            $('body').find('.loadmask').remove();
                        } catch (e) {

                        }
                        //do nothing for now
                    }
                });
        }
    },
    // Event responsible for removing a file from the page.
    // div: The div that will be removed, it contains the file info.
    // fileElement: The hidden textbox that will be removed.
    removeFile: function (element) {
        if (confirm("Are you sure you want to remove this attachment?")) {
            var fileUpload = this;
            Cobalt.Utils.getRequestVerificationToken().done(function(token) {
                $.post(
                    Cobalt.MultiFileUpload.deleteAttachmentRoute(
                        $(element).attr("data-model-type-id"),
                        $(element).attr("data-id")
                        ),
                    { 'request-verification-token': token },
                    function(result) {
                        if (result == "1") {
                            $(element).remove();

                            $(fileUpload.Form).trigger("fileRemoved", [fileUpload]);
                        } else {
                            if (result.Error) {

                            }
                        }
                    });
            });
        }
    },
    // Event responsible for attaching a new file to the page.
    // result: The JSON result for the file upload.
    attachFile: function (result, isDragged) {
        var fileUpload = this;
        // Check to see if attaching another file is allowed.
        if (($(fileUpload.FileInput).val() != "" || isDragged) && ((this.MaxFiles == -1) || ((this.MaxFiles > 0) && (this.CurrentFileCount < this.MaxFiles)))) {
            fileUpload.NewFileUpload = $('<input type="file" class="multi-file-upload">');
            fileUpload.NewFileUpload.attr("name", $(fileUpload.FileInput).attr("name"));
            // File info div
            this.displayFileInfo(result);
            $(fileUpload.FileInput).after(fileUpload.NewFileUpload);
            $(fileUpload.FileInput).remove();
            fileUpload.FileInput = fileUpload.NewFileUpload;

            $(fileUpload.Form).trigger("fileAttached", [fileUpload]);
        }
               
    },
    // Handles displaying error messages from the response.
    displayError: function (error) {
        var errorSpan = this.AttachToElement.find(".j-error-message");
        if (errorSpan.length == 0) {
            return;
        }
        errorSpan.empty();
        errorSpan.append(error);
        errorSpan.show();
        this.rebindAttachButton();
    },
    clearErrors : function() {
        var errorSpan = this.AttachToElement.find(".j-error-message");
        if (errorSpan.length === 0) {
            return;
        }
        errorSpan.empty();
        this.rebindAttachButton();
    },
    // Handles showing the file info.
    // result: The result for the file upload.
    displayFileInfo: function (result) {
        var fileUpload = this;
        var li = $(result);
        var ul = fileUpload.AttachToElement.find("ul");
        if (ul.length === 0) {
            ul = fileUpload.AttachToElement.append("<ul/>");
        }
        // Delete button
        var div = $('<div>');
        var removeButton = li.find(".j-remove-attachment");
        if (removeButton.length == 0) {
            removeButton = $("<button/>");
            removeButton.addClass("j-remove-attachment");
            removeButton.val(L.Global.Buttons.Delete());
            li.append(removeButton);
        }
        ul.append(li);
        if ($(fileUpload.AttachToElement).hasClass("no-results")) {
            $(fileUpload.AttachToElement).removeClass("no-results");
        }
        this.bindFileEvents(li);
        Cobalt.triggerHtmlInsert(ul);
        fileUpload.AttachToElement.show();
    },
    bindFileEvents: function (element) {
        var removeButton = $(element).find(".j-remove-attachment");
        var that = this;
        removeButton.click(function (e) {
            e.preventDefault();
            that.removeFile(element);
        });
    }
};


// WEBPACK FOOTER //
// ./content/js/Cobalt/Cobalt.MultiFileUpload.js